import React, { Fragment, useLayoutEffect, useState } from "react"
import { FormControl } from "react-bootstrap"
import { MdClose } from "react-icons/md"
import clsx from "clsx"

import { moment } from "utils"
import DatePicker from "./DatePicker"
import classes from "./DatePickerWithInput.module.scss"
import { useTranslation } from "react-i18next"

const DatePickerWithInput = props => {
  const {
    type = "datePicker",
    isClearable = false,
    error,
    label,
    disabled = false,
    minDate,
    maxDate,
    className,
    placeholder,
    range = [],
    value,
    onChange = () => { },
    onBlur = () => { },
    onFocus = () => { }
  } = props

  const i18n = useTranslation()[1]

  const [openDatePicker, setOpenDatePicker] = useState(false)
  const [movePlaceholder, setMovePlaceholder] = useState(false)

  const handleClear = e => {
    e.stopPropagation()

    const isRange =
      type === "rangeTimePicker" ||
      type === "rangeDatePicker"

    if (isRange) return onChange([])

    onChange("")
  }

  const getInputValue = () => {
    if (type === "datePicker" && !!value) {
      return moment(value).format("jYYYY/jMM/jDD")
    }

    if (type === "dateAndTimePicker" && !!value) {
      return moment(value).format("jYYYY/jMM/jDD - HH:mm")
    }

    if (type === "timePicker" && !!value) {
      return moment(`1970-01-01 ${value}`).format("HH:mm")
    }

    if (type === "rangeTimePicker" && !!range[0]) {
      return `${moment(`1970-01-01 ${range[1]}`).format("HH:mm")} ~ ${moment(`1970-01-01 ${range[0]}`).format("HH:mm")}`
    }

    if (type === "rangeDatePicker" && range.length > 0) {
      return `${moment(range[1]).format("jYYYY/jMM/jDD")} ~ ${moment(range[0]).format("jYYYY/jMM/jDD")}`
    }

    return ""
  }

  useLayoutEffect(() => {
    if (
      type === "rangeDatePicker" ||
      type === "rangeTimePicker"
    ) {
      setMovePlaceholder(!!range[0])
    } else {
      setMovePlaceholder(!!value)
    }
  }, [value, range])

  const inputValue = getInputValue()

  const showClearButton =
    isClearable &&
    !(range.length === 0 && !value)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={className}>
        <div className={classes["input-container"]}>
          {
            !!label &&
            <label
              className={clsx(
                classes["placeholder"],
                isLtr && classes["placeholder-ltr"],
                movePlaceholder && classes["move"]
              )}
            >
              {label}
            </label>
          }

          <FormControl
            readOnly
            onBlur={onBlur}
            value={inputValue}
            disabled={disabled}
            onFocus={onFocus}
            placeholder={placeholder}
            onClick={() => !disabled && setOpenDatePicker(true)}
            className={clsx(
              classes["input"],
              disabled && classes["disabled"],
              !!error && classes["input-error"]
            )}
          />
          {
            showClearButton &&
            <MdClose
              onClick={handleClear}
              className={classes["close"]}
            />
          }
        </div>
        {
          !!error &&
          <div className={classes["error"]}>
            {error}
          </div>
        }
      </div>
      <DatePicker
        type={type}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        range={range}
        value={value}
        onChange={onChange}
        openDatePicker={openDatePicker}
        setOpenDatePicker={setOpenDatePicker}
      />
    </Fragment>
  )
}

export default DatePickerWithInput